import { FC } from "react";
import styles from "./LinkCard.module.css";

export const LinkCard: FC<{
  children: React.ReactNode;
  to: string;
  title: string;
  description: string;
  stretch?: boolean;
}> = ({ children, title, to, description, stretch }) => {
  return (
    <mui-link href={to} variant="tertiary" class={`${styles.cardLink} ${stretch ? styles.stretch : ""}`}>
      <mui-v-stack {...(stretch && { fill: true })} space="var(--space-000)">
        <mui-v-stack
          space="var(--space-300)"
          style={{
            padding: "var(--space-500) var(--space-600)",
            borderBottom: "1px solid var(--grey-900)",
          }}
        >
          <mui-heading size="4" level="4">
            {title}
          </mui-heading>
          <mui-body size="small">{description}</mui-body>
        </mui-v-stack>
        {children}
      </mui-v-stack>
    </mui-link>
  );
};
